import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { buildPersonColorIndex, type PersonColorIndex } from '../lib/personColors';

/**
 * Personenfarben aus der Technikerliste (`['portal-technicians']` — dieselbe Abfrage wie die
 * Auswahllisten, also meist schon im Cache). Solange sie lädt, ist jeder grau.
 */
export function usePersonColors(): PersonColorIndex {
  const { data } = useQuery({
    queryKey: ['portal-technicians'],
    queryFn: () => api.getPortalTechnicians(),
    staleTime: 120_000,
  });
  return useMemo(() => buildPersonColorIndex(data?.technicians ?? []), [data]);
}
